// Import section and component remains unchanged
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect, lazy, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import google from "../images/search.png";
import axios from "axios";
import { getInitialize, signin } from "../../../../actions/action_auth";
import { getLandingRoute } from "../../../../utils/landingRoute";
import Validator from "validator";
import { useTheme } from "@mui/material/styles";
import "./custom.css";

// Lazy load step components for better performance
const Register = lazy(() => import("./Register"));
const Password = lazy(() => import("./Password"));
const MagicLink = lazy(() => import("./MagicLink"));

import {
  Box,
  Typography,
  Divider,
  TextField,
  CircularProgress,
  Link,
  Stack,
  Button as MUIButton,
} from "@mui/material";


const GettingStarted = ({ title, description }) => {

  const { publicOrCustom, sharedpoolId } = useParams();

  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const allClients = useSelector((state) => state.client.allClient);
  const [firstName, setFirstName] = useState("");
  const [data, setData] = useState({ email: "", password: "" });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [client, setClient] = useState();
  const storedData = localStorage.getItem("currentUrlfromMap");
  const prev = localStorage.getItem("prevURL") || null;
  const currentPath = window.location.pathname
  const customPath = currentPath.includes('custom')
  const {auth}=useSelector(state=>state.user.user)
  // console.log(currentPath, 'currentPath', customPath)

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      dispatch(getInitialize()).then((res) => {
        if ([500, 401, 403, 404].includes(res.data.response?.status)) {
          localStorage.removeItem("accessToken");
        } else {
          // Always check latest prevURL from localStorage
          const latestPrev = localStorage.getItem("prevURL");
          if (latestPrev) {
            console.log("Redirecting to prevURL:", latestPrev);
            navigate(latestPrev, { replace: true });
            localStorage.removeItem("prevURL");
          } else {
            navigate(getLandingRoute(res?.data?.user?.role), { replace: true });
          }
        }
      });
    }
  }, [navigate, dispatch]);

  // const handleGoogle = () => {
  //   const googleSignUrl = `${process.env.REACT_APP_API_URL}/api/auth/google-login`;
  //   // Store current path as prevURL before redirecting to Google login
  //   localStorage.setItem("prevURL", window.location.pathname + window.location.search);
  //   window.open(googleSignUrl, "_self");
  // };

  const handleGoogle = () => {
  // Store the current path before redirecting
  const currentPath = window.location.pathname + window.location.search;
  localStorage.setItem("prevURL", prev);
  
  // Add state parameter to maintain the redirect after OAuth
  const googleSignUrl = `${process.env.REACT_APP_API_URL}/api/auth/google-login?state=${encodeURIComponent(currentPath)}`;
  
  window.location.href = googleSignUrl; // Use href instead of open
};

  const validateEmail = () => {
    const validationErrors = {};
    if (!Validator.isEmail(data.email)) {
      validationErrors.email = "Invalid email format";
    }
    setErrors(validationErrors);
    return validationErrors;
  };

  const handleDataChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
    if ((name === "email" || name === "password") && value === "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  const handleEmailSubmit = async () => {
    setLoading(true);
    setErrorMessage("");
    const validationErrors = validateEmail();
    if (Object.keys(validationErrors).length > 0) {
      setLoading(false);
      return;
    }
    if (!data.email) {
      setErrorMessage("Please enter an email address.");
      setLoading(false);
      return;
    }
    try {
      const response = await axios.post(`/api/auth/check-if-account-exists`, {
        email: data.email,
      });
      if (response.data?.accountExists && response.data?.passwordExists) {
        setStep(1);
      } else if (
        response.data?.accountExists &&
        !response.data?.passwordExists
      ) {
        setStep(3);
        setFirstName(response.data.user.first_name);
      } else if (!response.data?.accountExists) {
        setStep(2);
      }
    } catch (error) {
      if (error?.response?.data?.reason === "invalid_business_email") {
        const emailPattern =
          /^[a-zA-Z0-9._%+-]+@(?!gmail\\.com|yahoo\\.com|hotmail\\.com|yahoo\\.co\\.in|aol\\.com|live\\.com|outlook\\.com)[a-zA-Z0-9_-]+\\.[a-zA-Z0-9-.]{2,61}$/;
        if (!emailPattern.test(data.email)) {
          setErrors({ email: "Please enter a valid business email" });
        }
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleEmailSubmit();
    }
  };
  const onSubmit = async () => {
    setLoading(true);
    try {
      const response = await dispatch(signin(data));
      const user = response.payload.user;
      const userRole = user.role;

      if (userRole === "partner" || userRole === "partnerClient") {
        navigate("/partner-talentpool");
        return;
      }

      const clientId = user.clientId;
      const clientData = allClients.find((client) => client._id === clientId);
      setClient(clientData);

      // Redirect to prevURL if it exists
      if (prev) {
        navigate(prev);
        localStorage.removeItem("prevURL");
        return;
      }

      if (window.location.pathname === "/signin") {
        if (userRole === "client") {
          if (sharedpoolId) {
            navigate(`/talent-pool/${user.clientId}?poolID=${sharedpoolId}`);
            localStorage.removeItem("prevURL");
          } else {
            navigate(getLandingRoute(userRole));
            // localStorage.removeItem("prevURL");
          }
        } else if (userRole === "Admin") {
          navigate("/jobs");
          // localStorage.removeItem("prevURL");
        } else {
          navigate(getLandingRoute(userRole));
          // localStorage.removeItem("prevURL");
        }
      }
    } catch (error) {
      const err = error.response?.data?.error;
      setErrors(
        err === "Email not provided!" ||
          err === "This email does not exist" ||
          err === "User is not activated"
          ? { email: err }
          : { password: err }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid #00000040",
        borderRadius: 2,
        boxShadow: "none",
        padding: "32px",
        position: "relative",
        textAlign: "center",
        background: "white",
        width: "100%",
      }}
    >
      <Suspense fallback={<CircularProgress sx={{ mt: 4 }} />}>
        {step === 0 && (
          <>
            <Typography
              variant="h5"
              fontWeight="bold"
              style={{
                color: theme.palette.custom.primaryBlue,
                marginBottom: "5px",
              }}
              my={2}
            >
              {title && auth ? title : 'Get Started with Qrata'}
            </Typography>
            <Typography
              mb={3}
              style={{ color: theme.palette.custom.secondaryTextGrey }}
            >
              {description && auth ? description : "De-risk your hire with our intelligence framework."}
            </Typography>
            <MUIButton
              fullWidth
              variant="outlined"
              onClick={handleGoogle}
              sx={{
                textTransform: "none",
                color: "#3f3f3f",
                backgroundColor: "#fff",
                borderColor: "#504949",
                fontWeight: 600,
                borderRadius: "8px",
                py: 1,
                fontSize: "1.1rem",
                mb: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={google}
                alt="google"
                width={20}
                style={{ marginRight: 10 }}
              />
              Continue with Google
            </MUIButton>
            <Divider sx={{ mb: 2, color: "#E3E3E3" }}>OR</Divider>
            <TextField
              fullWidth
              placeholder="Enter company email..."
              type="email"
              name="email"
              value={data.email}
              onKeyDown={handleKeyDown}
              onChange={handleDataChange}
              error={Boolean(errors.email)}
              helperText={errors.email}
              sx={{ mb: 2 }}
            />
            {errorMessage && (
              <Typography color="error">{errorMessage}</Typography>
            )}
            <MUIButton
              fullWidth
              variant="contained"
              onClick={handleEmailSubmit}
              className="continue-email-btn"
              sx={{
                color: theme.palette.custom.backgroundWhite,
                background: theme.palette.custom.primaryGreen,
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Continue with email"
              )}
            </MUIButton>
            <Typography mt={2} mb={2} color="#999" textAlign="left">
              By creating an account you consent to Qrata's{" "}
              <Link
                href="http://qrata.ai/terms-service.html"
                target="_blank"
                rel="noreferrer"
                underline="none"
                color="#999"
              >
                <u>Terms & Conditions</u>
              </Link>{" "}
              and{" "}
              <Link
                href="http://qrata.ai/privacy-policy.html"
                target="_blank"
                rel="noreferrer"
                underline="none"
                color="#999"
              >
                <u>Privacy Policy</u>
              </Link>
            </Typography>

            <Typography color="#504949" textAlign="left">
              Looking to grow?{" "}
              <Link
                href="https://talent.qrata.ai/"
                underline="always"
                color="#4F6C8D"
              >
                Continue as a talent
              </Link>
            </Typography>
          </>
        )}

        {step === 1 && (
          <Password
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
            data={data}
            handleDataChange={handleDataChange}
            onSubmit={onSubmit}
            errors={errors}
          />
        )}
        {step === 2 && (
          <Register email={data.email} setStep={setStep} setEmail={setEmail} />
        )}
        {step === 3 && (
          <MagicLink email={data.email} setStep={setStep} name={firstName} />
        )}
      </Suspense>
    </Box>
  );
};

export default GettingStarted;
